import { useState } from 'react';
import { tagGroups } from '@/mocks/homeData';
import SectionHeading from './SectionHeading';

export default function TagWall() {
  const [selected, setSelected] = useState<string[]>(['黑料导航怎么用', '标签筛选']);

  const toggle = (tag: string) => {
    setSelected((prev) => (prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]));
  };

  const clearAll = () => setSelected([]);

  return (
    <section id="tags" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <SectionHeading
            eyebrow="话题标签墙"
            title="按方向找入口，标签点选即可组合"
            desc="把内容按方向归好类，点选任意标签可叠加组合筛选。选得越多，范围越准，不必一页页翻。"
          />
          <div className="flex items-center gap-3">
            <span className="text-xs md:text-sm text-foreground-600">
              已选 <strong className="text-primary-700">{selected.length}</strong> 个标签
            </span>
            <button
              type="button"
              onClick={clearAll}
              className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md border border-background-300 text-foreground-700 text-xs md:text-sm hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-eraser-line"></i>
              清空重置
            </button>
          </div>
        </div>

        <div className="mt-10 space-y-6">
          {tagGroups.map((group) => (
            <div key={group.name} className="flex flex-col md:flex-row gap-3 md:gap-6">
              <div className="md:w-28 shrink-0 flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                {group.name}
              </div>
              <div className="flex flex-wrap gap-2 md:gap-3">
                {group.tags.map((tag) => {
                  const active = selected.includes(tag);
                  return (
                    <button
                      key={tag}
                      type="button"
                      onClick={() => toggle(tag)}
                      className={`px-3.5 py-2 rounded-full text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap border ${
                        active
                          ? 'bg-primary-500 text-background-50 border-primary-500'
                          : 'bg-background-50 text-foreground-700 border-background-200 hover:border-primary-300 hover:text-primary-700'
                      }`}
                    >
                      {active && <i className="ri-check-line mr-1"></i>}
                      {tag}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}